<template>
<div>
    <div class="feed-list__loading" v-if="!feedDataList.length && loadingStatus === loadingStatusConfig.loading">
        <div class="loading icon icon-loading"></div>
        为您推荐中
    </div>
    <div v-if="feedDataList.length" data-spm="feed"  id="collection-sp-style">
        <RecommendFeed 
            :feed-type="3" 
            :data-measure-config = "measureConfig" 
            :data="feedDataList">
        </RecommendFeed>
        <div>
            <footer class="feed-list__loading" v-if="loadingStatus === loadingStatusConfig.loading">
                <div class="loading icon icon-loading"></div>
                为您推荐中
            </footer>
            <footer class="feed-list__loading" v-if="loadingStatus === loadingStatusConfig.error">暂时没有更多内容了……</footer>
        </div>
    </div>
    <div class="noData-content" v-if="isShowEmpty">
        <p class="nodata-info">剪报暂未添加文章</p>
    </div>
</div>
</template>

<script>
    import RecommendFeed from 'common-components/lib/recommendFeed'
    import 'common-components/lib/recommendFeed/index.css'
    import EventHelper from '../_utils/eventHelper';
    import PicUtils from '../_utils/pic-util';
    const loadingStatusConfig = {
        default: 'default',  // 默认，未加载
        loading: 'loading',  // 加载中
        error: 'error'     // 数据为空or加载失败
    }
    export default {
        name: 'ColumnList',
        components: {
            RecommendFeed
        },
        props: {
            articleId: Number
        },
        data() {
            return {
                measureConfig: {},
                isShowEmpty: false,
                feedDataList: [],
                loadingStatusConfig: loadingStatusConfig,
                loadingStatus: loadingStatusConfig.default,  //loading状态
                page: 1,
            }
        },
        mounted() {
            this.init();
            this.getColumnList();
        },
        methods: {
            init() {
                let buffer = 100;
                EventHelper.addHandler(window, 'scroll', ()=>{
                    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                    var scrollHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
                    var clientHeight =  document.body.clientHeight || document.documentElement.clientHeight
                    if (scrollTop >= scrollHeight - clientHeight - buffer && this.loadingStatus === this.loadingStatusConfig.default) {
                        this.getColumnList()
                    }
                })
            },
            setPicSize(url, width, height) {
                 return PicUtils.setPicSize(url, width, height, 'c_fill');
            },
             //获取栏目数据
            getColumnList () {
                this.loadingStatus = this.loadingStatusConfig.loading
                let url = `//v2.sohu.com/article-service-api/collection/articles/${this.articleId}?pno=${this.page}`;
                let tag = {
                    borderColor: "#F7B2B2",
                    name: "置顶",
                    textColor: "#FC4B4B",
                }
                $.ajax({
                    type: 'GET',
                    url: url,
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    success: res=> {
                        if(!res.data || res.data.length === 0){
                            if(this.page == 1) {
                                this.loadingStatus = null
                                this.isShowEmpty = true
                            }else {
                                this.loadingStatus = this.loadingStatusConfig.error
                            }
                            return
                        }
                        let feedData =  res.data;
                        for(let i =0; i<feedData.length; i++) {
                            if(feedData[i].priority == 1) {
                                feedData[i].tag = tag
                            }
                            if(feedData[i].images.length) {
                                feedData[i].isPicture = true;
                                let imgs = feedData[i].images;
                                for(let i =0; i<imgs.length; i++) {
                                    imgs[i] =this.setPicSize(imgs[i], 228, 148)
                                }
                            }
                        }

                        this.page++;
                        this.feedDataList.push(...feedData);
                        this.loadingStatus = this.loadingStatusConfig.default
                        this.$nextTick(() => (window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') && window.sohuSpm.domDidChange({target: 'feed'}))
                    },
                    error: res => {
                        this.loadingStatus = this.loadingStatusConfig.error
                    }
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .noData-content {
        margin: 0 60px;
        .nodata-info {
            margin-top: 226px;
            text-align: center;
            font-size: 30px;
            color: #A4A4A4;
        }
    }
</style>
